/**
 * react-hot-loader needs to be required before React, per https://github.com/gaearon/react-hot-loader.
 */
import './styles';
import {hot} from 'react-hot-loader';
import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {render} from 'react-dom';
import {Provider as ReduxProvider} from 'react-redux';
import {store} from '~/redux/store';
import Routes from './Routes';
import {PingAuthProvider} from './lib/auth/ping/PingAuthProvider';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

const REACT_ROOT_ID = 'root';
const queryClient = new QueryClient({
    defaultOptions: {queries: {retry: 3, retryDelay: 30, retryOnMount: true}},
});

const initialize = (App: () => any) => {
    render(
        <PingAuthProvider>
            <App />
        </PingAuthProvider>,
        document.getElementById(REACT_ROOT_ID)
    );
};

const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <ReduxProvider store={store}>
                <Router>
                    <Routes />
                </Router>
            </ReduxProvider>
        </QueryClientProvider>
    );
};

const HotApp = hot(module)(App);

initialize(HotApp);
